import React from 'react'
import {PanelWrapper} from "./PanelWrapper";
import {Card} from "../Card";
import {isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {EmptyState} from "../EmptyState";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";
import {type SelectedItemsData} from "../../EntitySelector/EntitySelector.types";
import useGetZones from "../../../hooks/api/useGetZones";
import {Zone} from "../../../types/Zone";

// Types ----

type ZonesPanelProps = {
  onSelect: (zone: Zone) => void
  selectedItems: SelectedItemsData
  siteId?: number | null
  isMaxSelected?: boolean
  isMultiSite?: boolean
}

// Component ----

function ZonesPanel({ onSelect, selectedItems, siteId, isMaxSelected, isMultiSite }: ZonesPanelProps) {
  const {data: zones, isLoading} = useGetZones({
    site: siteId?.toString(),
    per_page: 1000,
    hidden: true,
  });

  return (
      <PanelWrapper isLoading={isLoading}>
        {isLoading ?
          loadingSkeleton :
          <>
            {!!zones?.data?.length ? zones?.data.map(zone => {
                const selected = isSelected(zone, ENTITY_TYPES.ZONE, selectedItems);

                return (
                  <Card
                    key={zone.id}
                    onClick={() => onSelect(zone)}
                    heading={zone.name}
                    footer={isMultiSite ? zone.site.name : null}
                    active={selected}
                    disabled={isMaxSelected && !selected}
                  />
                )
              }) :
              <EmptyState />
            }
          </>
        }
      </PanelWrapper>
  );
}

export {ZonesPanel};